import { useEffect } from "react";
import { getPlatformInfo } from "../util/platformDetection";

const CHROMEOS_BODY_CLASS = "chromeos-platform";

/**
 * Hook that adds ChromeOS-specific CSS class to body element
 * for platform-specific styling (like sticky scrollbars)
 */
export const useChromeOSPlatform = (): void => {
  useEffect(() => {
    const platformInfo = getPlatformInfo();

    if (platformInfo.isChromeOS) {
      // Add ChromeOS class to body
      document.body.classList.add(CHROMEOS_BODY_CLASS);
    } else {
      // Remove ChromeOS class if not on ChromeOS (safety)
      document.body.classList.remove(CHROMEOS_BODY_CLASS);
    }

    // Cleanup function to remove class on unmount
    return () => {
      document.body.classList.remove(CHROMEOS_BODY_CLASS);
    };
  }, []); // Run once on mount
};
